import Vue from 'vue'
import router from '@/router/router'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import VueI18n from 'vue-i18n'
import VueTheMask from 'vue-the-mask'
import PortalVue from 'portal-vue'
import BackToTop from 'vue-backtotop'
import Vuelidate from 'vuelidate'
import money from 'v-money'
import debug from '@/util/debug'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const fnm = 'main.js'

Vue.use(VueTheMask)
Vue.use(PortalVue)
Vue.use(Vuelidate)

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ptBR'
})

Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  i18n,
  dictionary: {
    ptBR
  }
})

Vue.use(BootstrapVue)
Vue.use(BackToTop)
Vue.use(money, {precision: 2});

Vue.config.productionTip = false
Vue.config.devtools = true

debug(null, 'Vue', fnm)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
